import { render, staticRenderFns } from "./ClassificationsHandbook.vue?vue&type=template&id=0b530b82&scoped=true&"
import script from "./ClassificationsHandbook.vue?vue&type=script&lang=js&"
export * from "./ClassificationsHandbook.vue?vue&type=script&lang=js&"
import style0 from "./ClassificationsHandbook.vue?vue&type=style&index=0&id=0b530b82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b530b82",
  null
  
)

export default component.exports